import React, { FC } from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import { scale } from '@components/frame';
import { isWeb } from '@helpers';
import { ScrollToTopButtonProps } from '@components/ncFileVersions/types';

const ScrollToTopButton: FC<ScrollToTopButtonProps> = ({ C, visible, onPress }) => {
  // Only render on web
  if (!isWeb) {
    return null;
  }

  if (!visible) {
    return null;
  }

  return (
    <TouchableOpacity
      style={[
        styles.container,
        { backgroundColor: C('Button/Light/Secondary'), shadowColor: C('Label/Light/Primary') },
      ]}
      onPress={onPress}
      activeOpacity={0.7}
    >
      <Text style={[styles.icon, { color: C('Label/Light/Primary') }]}>↑</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: scale(32),
    right: scale(32),
    width: scale(48),
    height: scale(48),
    borderRadius: scale(24),
    alignItems: 'center',
    justifyContent: 'center',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 5,
    zIndex: 1000,
  },
  icon: {
    fontSize: scale(24),
    fontWeight: 'bold',
  },
});

export default ScrollToTopButton;
